const ACTIONS = {
  LOAD_EMPLOYEE_DOCS_REQ: "LOAD_EMPLOYEE_DOCS_REQ",
  LOAD_EMPLOYEE_DOCS_SUCCESS: "LOAD_EMPLOYEE_DOCS_SUCCESS",
  LOAD_EMPLOYEE_DOCS_FAILURE: "LOAD_EMPLOYEE_DOCS_FAILURE",

};

export default ACTIONS;
